// @ts-ignore
import inEU from '@segment/in-eu'
import { isServerSide } from 'lib/env'

// guard because fn assumes client-side
export const isEU = (): boolean => !isServerSide && inEU()
